import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=9f05d320&scoped=true"
import script from "./confirm.vue?vue&type=script&lang=js"
export * from "./confirm.vue?vue&type=script&lang=js"
import style0 from "./confirm.vue?vue&type=style&index=0&id=9f05d320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f05d320",
  null
  
)

export default component.exports